import { useRef, useState } from "react";
import { CiEdit } from "react-icons/ci";
import { MdLogout } from "react-icons/md";
import { uploadFileToAzure } from "../../../services/azure";
import { useStores } from "../../../store";
import userpic from "../../../assests/userdefaultpic.jpeg";
import ConfirmationPopup from "./confirmationpopup";
import VersionDisplay from "../VersionDisplay";
import { logout } from "../../../api/api_methods";
const EditIcon = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("user"))?.pic || userpic
  );
  const { UserStore } = useStores();
  const [showPopup, setShowPopup] = useState(false);
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const timestamp = Date.now().toString();
    const randomNumber = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
    const filename = randomNumber + timestamp;

    setIsLoading(true);
    const fileUploaded = await uploadFileToAzure(filename, file, {
      action: "profile",
    });

    setProfile(fileUploaded.url);
    UserStore.setUserPic(fileUploaded.url);
    let body = { pic: fileUploaded.url };
    await UserStore.updateUserDetailsToServer(body).then((res) => {
      console.log(res);
    });

    setIsLoading(false);
  };

  const userLogOut = () => {
    try {
      localStorage.removeItem("user");
      localStorage.removeItem("user_google");
      sessionStorage.clear();
      window.location.href = "/";
    } catch (error) {
      console.log(error);
      window.location.href = "/";
    }
    window.location.href = "/";
    setShowPopup(false);
  };

  return (
    <div className="bg-[#FBF7F2] flex relative w-full items-center h-36 md:pl-5 lg:pl-5">
      <VersionDisplay isCompany={true} />
      <div className="flex items-center space-x-3 mt-20">
        {/* Profile Picture Container */}
        <div className="relative w-20 h-20">
          <input
            type="file"
            className="hidden"
            ref={fileInputRef}
            accept=".png, .jpeg, .jpg"
            onChange={handleFileChange}
          />
          <img
            src={profile}
            alt="Profile"
            className="w-20 h-20 rounded-full object-cover border-2 border-gray-300"
            onError={(e) => (e.target.src = userpic)}
          />
          {/* Edit Button */}
          <div
            className="absolute bg-white rounded-full right-0 bottom-0 p-1 flex items-center justify-center text-orange-500 cursor-pointer shadow-md"
            onClick={handleButtonClick}
          >
            <CiEdit size={18} />
          </div>
        </div>
      </div>

      {/* User Details */}
      <div>
        <h1 className="md:text-lg lg:text-lg text-xl font-bold md:mt-12 lg:mt-12 mt-24 md:ml-4 lg:ml-4 ml-2 lg:font-medium md:font-medium">
          {JSON.parse(localStorage.getItem("user"))?.companyName?.length > 10
            ? `${JSON.parse(localStorage.getItem("user"))?.companyName?.substring(
                0,
                10
              )}...`
            : JSON.parse(localStorage.getItem("user"))?.companyName || ""}
        </h1>
        <p className="md:text-xs lg:text-xs text-[12px] md:ml-4 lg:ml-4 ml-2 text-orange-500">
          ID: {JSON.parse(localStorage.getItem("user"))?._id}
        </p>
      </div>

      {/* Logout Button */}
      <button onClick={() => setShowPopup(true)}>
        <div className="flex md:hidden lg:hidden text-[#FF6B00] items-center gap-2 ml-4 pt-28 cursor-pointer">
          <MdLogout className="lg:block md:block ml-11" />
          <span className="hidden sm:inline">Logout</span>
        </div>
      </button>

      {/* Logout Confirmation Popup */}
      {showPopup && (
        <ConfirmationPopup
          message="Do you really want to log out?"
          cancelButton="Yes, Logout"
          onClick={() => setShowPopup(false)}
          onConfirm={async () => {
            await logout();
            userLogOut();
          }}
          onCancel={() => setShowPopup(false)}
        />
      )}
    </div>
  );
};

export default EditIcon;
